// extracted by mini-css-extract-plugin
export var button = "_mn-2";
export var card = "_mn-0";
export var closeButtonContainer = "_mn-3";
export var iconContainer = "_mn-1";